import { rei } from "@/services/api"

class RelatorioSelosService {
  static getPdfRelatorio (busca) {
    return rei.post(`relatorio-selos`, busca, { responseType: 'arraybuffer' }).then((res) => {
      let blob = new Blob([res.data], { type: 'application/pdf' })
      let url = window.URL.createObjectURL(blob)

      return url
    })
  }

}

export default RelatorioSelosService
